import React, { useState, useMemo } from "react";
import { Card, CardBody, Container } from "reactstrap";
import { useCurrentUser } from "../../slices/auth/hooks";
import { useNavigate } from "react-router-dom";
import ResourcesTabs from "../../Components/Tabs/ResourcesTabs";
import DownloadableResource from "./components/DownloadableResource";
import SessionsResources from "./components/RenderResoursesVideos";
import GeneralResources from "./components/GeneralResources";
import EmployerResources from "./components/EmployerResources";
import NationalsResources from "./components/NationalsResources";
import { DASHBOARD_USER_ROLES } from "../../constants";
import BrokersResources from "./components/BrokersResources";
import GaResources from "./components/GaResources";

const allResourcesTabs = [
  // {
  //   id: "1",
  //   name: "general",
  //   label: "General",
  //   component: <GeneralResources />,
  // },
  {
    id: "2",
    name: "nationals",
    label: "Nationals",
    component: <NationalsResources />,
    roles: [DASHBOARD_USER_ROLES.NATIONAL, DASHBOARD_USER_ROLES.ADMIN],
  },
  {
    id: "3",
    name: "brokers",
    label: "Brokers",
    component: <BrokersResources />,
    roles: [DASHBOARD_USER_ROLES.BROKER, DASHBOARD_USER_ROLES.ADMIN],
  },
  {
    id: "4",
    name: "gas",
    label: "GA's",
    component: <GaResources />,
    roles: [DASHBOARD_USER_ROLES.GA, DASHBOARD_USER_ROLES.ADMIN],
  },
  {
    id: "5",
    name: "employer",
    label: "Employer",
    component: <EmployerResources />,
  },
  {
    id: "6",
    name: "marketingMaterial",
    label: "Marketing Material",
    component: <DownloadableResource />,
  },
];

const DashboardResources = () => {
  const navigate = useNavigate();
  const user = useCurrentUser();

  // Filter and reassign IDs to available tabs
  const availableTabs = useMemo(() => {
    const filtered = allResourcesTabs.filter((tab) => {
      // If tab has roles defined, check if user role is included
      if (tab.roles) {
        return tab.roles.includes(user?.role);
      }
      // If no roles defined, tab is available to everyone
      return true;
    });

    // Reassign sequential IDs starting from "1"
    return filtered.map((tab, index) => ({
      ...tab,
      id: (index + 1).toString(),
    }));
  }, [user?.role]);

  // Set initial active tab to the first available tab
  const [activeTab, setActiveTab] = useState(() => {
    return availableTabs.length > 0 ? availableTabs[0].id : "1";
  });

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderActiveTab = () => {
    const tab = availableTabs.find((tab) => tab.id === activeTab);
    return tab ? tab.component : null;
  };

  return (
    <div className="page-content px-0 ">
      <Container fluid>
        <Card>
          <CardBody>
            <div className="p-3 d-flex align-items-center justify-content-between">
              <div className="d-flex flex-column">
                <h3 className=" fw-bold  text-dark d-flex align-items-center">
                  <i
                    onClick={() => navigate("/profile")}
                    className="ri-arrow-left-s-line me-3 fs-3 cursor-pointer"
                  ></i>
                  Resources
                </h3>
              </div>
            </div>
            {availableTabs.length > 0 && (
              <>
                <ResourcesTabs
                  loading={false}
                  tabs={availableTabs}
                  toggleTab={toggleTab}
                  activeTab={activeTab}
                />
                {renderActiveTab()}
              </>
            )}
            {availableTabs.length === 0 && (
              <div className="text-center p-4">
                <p>No resources available for your role.</p>
              </div>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default DashboardResources;